<ng-container *ngIf="informacionPerfil && informacionPerfil.mensajeINTPTO">
    <div class="no-hay-informacion">
        <label>{{ informacionPerfil.mensajeINTPTO }}</label>
    </div>
  </ng-container>
<div *ngIf="informacionPerfil && !informacionPerfil.mensajeINTPTO">
    <p-table [value]="resumenCreditos" class="tabla-vectores tabla-vectores-crezcamos">
        <ng-template pTemplate="header">
            <tr>
                <th colspan="6">{{ 'PERFILCREZCAMOS.LBL_CREDITOSVIGENTESCREZCAMOS' | translate }}</th>
            </tr>
            <tr>
                <th *ngFor="let title of arrayTitleColumns">{{ title }}</th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-credito>
            <tr>
                <td class="role">{{ credito.rol }}</td>
                <td>{{ credito.cantidad }}</td>
                <td>{{ credito.cuota | formatCurrency }}</td>
                <td>{{ credito.pagoTotal | formatCurrency }}</td>
                <td>
                    <svg *ngIf="credito.indicadorBandera" xmlns="http://www.w3.org/2000/svg" width="11" height="17" viewBox="0 0 11 17" fill="none">
                        <path d="M0 16.5H2V8L11 5L2 1.5V0H0V16.5Z" fill="#F15A24"/>
                    </svg>
                    {{ credito.diasMora }}
                </td>
                <td>{{ credito.valorMora | formatCurrency }}</td>
            </tr>
        </ng-template>
    </p-table>
</div>
